var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chuchuang"},[_c('router-view',{attrs:{"form":_vm.form},on:{"onSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }